export interface ContainedRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export const getObjectContainRect = (
  containerWidth: number,
  containerHeight: number,
  mediaWidth: number,
  mediaHeight: number
): ContainedRect => {
  if (!containerWidth || !containerHeight || !mediaWidth || !mediaHeight) {
    return { x: 0, y: 0, width: containerWidth, height: containerHeight };
  }
  const scale = Math.min(
    containerWidth / mediaWidth,
    containerHeight / mediaHeight
  );
  const width = mediaWidth * scale;
  const height = mediaHeight * scale;
  return {
    x: (containerWidth - width) / 2,
    y: (containerHeight - height) / 2,
    width,
    height,
  };
};

export const normalizeZonePolygons = (coordinates: unknown): number[][][] => {
  if (!Array.isArray(coordinates) || coordinates.length === 0) {
    return [];
  }
  const first = coordinates[0];
  if (!Array.isArray(first)) {
    return [];
  }
  if (typeof first[0] === "number") {
    return [coordinates as number[][]];
  }
  return (coordinates as number[][][]).filter(
    (polygon) => Array.isArray(polygon) && polygon.length > 0
  );
};

export const polygonToSvgPoints = (polygon: number[][]): string =>
  polygon
    .filter((point) => Array.isArray(point) && point.length >= 2)
    .map(([x, y]) => `${x},${y}`)
    .join(" ");

export const getDetectionMarkerRatio = ({
  durationSeconds,
  approxCaptureTimestamp,
  clipStartTimestamp,
}: {
  durationSeconds: number;
  approxCaptureTimestamp?: string | number | null;
  clipStartTimestamp?: string | number | null;
}): number | null => {
  // `null` = unknown: the player hides the marker rather than drawing it at
  // an invented mid-clip position (ENG-1663).
  if (!durationSeconds || durationSeconds <= 0) {
    return null;
  }
  if (
    approxCaptureTimestamp == null ||
    clipStartTimestamp == null ||
    approxCaptureTimestamp === "" ||
    clipStartTimestamp === ""
  ) {
    return null;
  }
  let capture = Number(approxCaptureTimestamp);
  let start = Number(clipStartTimestamp);
  if (!Number.isFinite(capture) || !Number.isFinite(start)) {
    return null;
  }
  if (capture > 1e12) capture /= 1000;
  if (start > 1e12) start /= 1000;
  const offset = capture - start;
  if (offset >= 0 && offset <= durationSeconds) {
    return offset / durationSeconds;
  }
  return null;
};

export const formatPlayerTime = (seconds: number): string => {
  if (!Number.isFinite(seconds) || seconds < 0) {
    return "0:00";
  }
  const total = Math.floor(seconds);
  const minutes = Math.floor(total / 60);
  const remainder = total % 60;
  return `${minutes}:${remainder.toString().padStart(2, "0")}`;
};
